import { FaGithub, FaXTwitter } from 'react-icons/fa6';
import { IoCallOutline } from 'react-icons/io5';
import { SlSocialLinkedin } from 'react-icons/sl';
import { TfiEmail } from 'react-icons/tfi';
import { Contact } from '../types/contacts';

// const FacebookIcon = FaFacebookSquare as React.ComponentType<{
//   size?: number;
//   color?: string;
// }>;
const SLLinkedinIcon = SlSocialLinkedin as React.ComponentType<{
  size?: number;
  color?: string;
}>;
const EmailIcon = TfiEmail as React.ComponentType<{
  size?: number;
  color?: string;
}>;

const GithubIcon = FaGithub as React.ComponentType<{
  size?: number;
  color?: string;
}>;

const PhoneIcon = IoCallOutline as React.ComponentType<{
  size?: number;
  color?: string;
}>;

const TwitterIcon = FaXTwitter as React.ComponentType<{
  size?: number;
  color?: string;
}>;

export const CONTACTS: Contact[] = [
  {
    icon: SLLinkedinIcon,
    navigate: 'https://www.linkedin.com/in/mustafakamel17/',
    color: '#0077B5',
    activeColor: '#0A66C2',
    size: 31,
  },
  //   {
  //     icon: FacebookIcon,
  //     navigate: 'https://www.facebook.com/mospro17/',
  //     color: '#1877F2',
  //     activeColor: '#1661C9',
  //   },
  {
    icon: EmailIcon,
    navigate: 'mailto:mustafakamel@gmail.com',
    color: '#D44638',
    activeColor: '#A8362C',
    size: 33,
  },
  {
    icon: GithubIcon,
    navigate: 'https://github.com/mustafakameldev',
    color: '#333',
    activeColor: 'white',
    size: 30,
  },
  {
    icon: TwitterIcon,
    navigate: 'https://twitter.com/MosPro17',
    color: '#000000',
    activeColor: '#FFFFFF',
    size: 30,
  },
  {
    icon: PhoneIcon,
    navigate: 'tel:+201010026329',
    color: '#4CAF50',
    activeColor: '#388E3C',
    size: 30,
  },
  // {
  //   icon: PhoneIcon,
  //   navigate: 'tel:+201000000000',
  //   color: '#4CAF50',
  //   activeColor: '#388E3C',
  // },
];
